import { isModuleEnabled, isCategoryEnabled } from '../helpers/modules';

/**
 * ModuleGate — מציג את ה-children רק אם המודול/הקטגוריה פעילים לחברה.
 * משמש לעטיפת פריטי תפריט (<li>) בתפריט הצד.
 *
 *   <ModuleGate code="Report.Reference"> <li>...</li> </ModuleGate>
 *   <ModuleGate category="Reports"> <li>...כותרת קטגוריה...</li> </ModuleGate>
 *
 * מחזיר את ה-children ישירות (ללא DOM נוסף) כדי לא לשבור את מבנה MetisMenu.
 */
const ModuleGate = ({ code, category, children }) => {
  const visible = category ? isCategoryEnabled(category) : isModuleEnabled(code);
  return visible ? children : null;
};

export default ModuleGate;
